// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PspL-","footer_wrapper":"Footer_footer_wrapper__z5Ko0"};